import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Alert, CircularProgress, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RoleQueries } from '@portal/app-admin'

function RolesErrorComponent() {
  const { t } = useTranslation('admin-console')
  return <Alert severity="error">{t('roles.table.error')}</Alert>
}

/**
 * Shared concerns only - the entitlement guard, the roles list and Entity Type scope setting the
 * children read, and the pending and error states. Deliberately no page content: the detail page
 * is a child of this route, so anything rendered here would appear above it.
 */
export const Route = createFileRoute('/_auth/preferences/roles')({
  component: () => <Outlet />,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Role', 'MANAGE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(RoleQueries.list()),
      queryClient.ensureQueryData(RoleQueries.scopeSettings()),
    ]),
  pendingComponent: () => (
    <Stack sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <CircularProgress />
    </Stack>
  ),
  errorComponent: RolesErrorComponent,
})
